import { VdsIconButton } from '@volt/volt-extended-components-react';
import { ReactElement, useCallback, useMemo } from 'react';
import { ModelWithId } from '@casops/store/apis/commonModels';
import { ModelDownloadProps } from '../../ModelActionsCellRenderer';

const onDownload = (uri: string): void => {
  if (uri) {
    window.open(uri, '_blank', 'noopener,noreferrer');
  }
};

interface DownloadActionProps<TData extends ModelWithId> extends ModelDownloadProps<TData> {
  data: TData;
}

export const DownloadAction = <TData extends ModelWithId>({
  data,
  showDownloadItem,
  canDownloadItem,
  getDownloadUrl,
}: DownloadActionProps<TData>): ReactElement | null => {
  const isDownloadItemAllowed = useMemo(() => {
    return typeof canDownloadItem === 'function' ? canDownloadItem(data) : canDownloadItem;
  }, [data, canDownloadItem]);

  const isShowDownloadItem = useMemo(() => {
    return typeof showDownloadItem === 'function' ? showDownloadItem(data) : showDownloadItem;
  }, [data, showDownloadItem]);

  const onClick = useCallback(() => {
    const url = getDownloadUrl(data);
    onDownload(url);
  }, [data, getDownloadUrl]);

  return isShowDownloadItem ? (
    <VdsIconButton
      icon="download"
      onClick={isDownloadItemAllowed ? onClick : undefined}
      disabled={!isDownloadItemAllowed}
    />
  ) : null;
};

export default DownloadAction;
